import {SerializedError} from "@reduxjs/toolkit";
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

export const hasPhoneError = (error: FetchBaseQueryError | SerializedError): error is FetchBaseQueryError & {data: {phone: string[]}} => {
    if (!error) {
        return false;
    }
    return !!(error && "data" in error && typeof error.data === "object" && error.data && "phone" in error.data);
};
import {SerializedError} from "@reduxjs/toolkit";
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

export const hasPhoneError = (error: FetchBaseQueryError | SerializedError): error is FetchBaseQueryError & {data: {phone: string[]}} => {
    if (!error) {
        return false;
    }
    return !!(error && "data" in error && typeof error.data === "object" && error.data && "phone" in error.data);
};
